export default [

  {
    path: '/gz-robot/index',
    name: 'Index',
    component: () => import('@/views/gz-robot/index'),
    meta: {
      title: '招办答疑-高考直通车',
      shareimg:'https://img.gaokaozhitongche.com/static/gkztclogo.png',
      sharedsc:'AI机器人语音答疑，招办老师在线服务'
    }
  },
  {
    path: '/gz-robot/talk/:id',
    name: 'Talk',
    component: () => import('@/views/gz-robot/talk'),
    meta: {
      title: '招办答疑-高考直通车',
      shareimg:'https://img.gaokaozhitongche.com/static/gkztclogo.png',
      sharedsc:'AI机器人语音答疑，招办老师在线服务'
    }
  },
  {
    path: '/gz-robot/admin',
    name: 'Admin',
    component: () => import('@/views/gz-robot/admin'),
    meta: {
      title: '招办答疑-高考直通车',
    }
  },
]
